import { ISelectOption } from '@salecycle/ui-component-library';
import { LD_EMAIL_TRACKING_CONSENT_FLAG } from 'core/constants/EmailTrackingUnsubscribeSettings';
import { TFunction } from 'i18next';
import {
  DEFAULT_EMAIL_TRACKING_UNSUBSCRIBE_PAGE_TEMPLATE,
  DEFAULT_REMARKETING_EMAIL_TEMPLATE,
  DEFAULT_UNSUBSCRIBE_PAGE_TEMPLATE,
  DEFAULT_RCS_TEMPLATE,
} from './default-templates';

/** Email-tracking template types hidden when ld-email-tracking-consent is off. */
const EMAIL_TRACKING_TEMPLATE_TYPES = new Set(['unsubscribeEmailTracking', 'globalUnsubscribeEmailTracking']);

export const getTemplateTypeOptions = (types, channel, t: TFunction, flagEnabled?: (flag: string) => boolean) => {
  let templateTypes: string[];
  if (types) {
    templateTypes = Object.keys(types);
    if (channel === 'sms' || channel === 'rcs') {
      const allowedMobileTypes = ['cartAbandonment', 'browseAbandonment'];
      templateTypes = templateTypes.filter(element => allowedMobileTypes.includes(element));
    }
  }

  if (channel !== 'email') {
    templateTypes = templateTypes.filter(s => s !== 'bulkRetargeting');
  }

  if (!flagEnabled?.(LD_EMAIL_TRACKING_CONSENT_FLAG)) {
    templateTypes = templateTypes.filter(type => !EMAIL_TRACKING_TEMPLATE_TYPES.has(type));
  }

  const typeOptions: ISelectOption<string>[] = templateTypes
    ? templateTypes.sort().map(item => {
        return { value: item, label: t('designs:designGallery.form.templateType.' + item) };
      })
    : [];

  return typeOptions;
};

export const getOnsiteTemplateTypeOptions = (t: TFunction, flagEnabled: (flag: string) => boolean) => {
  const templateTypes = ['emailAcquisition', 'sendMyBasket'];

  if (flagEnabled('ld-onsite-display-only')) {
    templateTypes.push('displayOnly');
  }

  const typeOptions: ISelectOption<string>[] = templateTypes
    ? templateTypes.sort().map(item => {
        return { value: item, label: t('designs:designGallery.form.templateType.' + item) };
      })
    : [];
  return typeOptions;
};

export const getMPSTemplateTypeOptions = (t: TFunction) => {
  const templateTypes = ['mpsEmbed', 'mpsPopup'];

  const typeOptions: ISelectOption<string>[] = templateTypes
    ? templateTypes.sort().map(item => {
        return { value: item, label: t('designs:designGallery.form.templateType.' + item) };
      })
    : [];

  return typeOptions;
};

export const getDefaultEmailTemplate = (templateType: string) => {
  if (templateType === 'unsubscribe') {
    return DEFAULT_UNSUBSCRIBE_PAGE_TEMPLATE;
  }
  if (templateType === 'unsubscribeEmailTracking' || templateType === 'globalUnsubscribeEmailTracking') {
    return DEFAULT_EMAIL_TRACKING_UNSUBSCRIBE_PAGE_TEMPLATE;
  }
  return DEFAULT_REMARKETING_EMAIL_TEMPLATE;
};

export const getDefaultSMSTemplate = () => 'This is an SMS Default placeholder';

export const getDefaultRCSTemplate = () => DEFAULT_RCS_TEMPLATE;

export const getDefaultTemplateBody = (channel: string, templateType: string): string =>
  channel === 'sms'
    ? getDefaultSMSTemplate()
    : channel === 'rcs'
    ? getDefaultRCSTemplate()
    : getDefaultEmailTemplate(templateType);

export const getCreateTemplateHeadingKey = (channel: string): string =>
  channel === 'sms'
    ? 'designs:designGallery.form.createSMSTemplate'
    : channel === 'rcs'
    ? 'designs:designGallery.form.createRCSTemplate'
    : 'designs:designGallery.form.createEmailTemplate';
